import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "grid-box grid-col",
  id: "leads-page"
}
const _hoisted_2 = { class: "page-content grid-box grid-row" }
const _hoisted_3 = { class: "left-col grid-box grid-col" }
const _hoisted_4 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "text" }
const _hoisted_7 = { class: "text" }
const _hoisted_8 = { class: "grid-con row grid-row" }
const _hoisted_9 = { class: "text" }
const _hoisted_10 = { class: "text" }
const _hoisted_11 = { class: "selected-item grid-col scroll-y" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["filterHeader"], {
      "active-toggle-main": $setup.activeToggleMain,
      "active-toggle-three": $setup.activeToggleThree,
      onSortChanged: $setup.handleSortChanged
    }, null, 8, ["active-toggle-main", "active-toggle-three"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["list grid-box grid-col scroll-y", {'loading': $setup.loading}])
        }, [
          ($setup.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[0] || (_cache[0] = [
                _createElementVNode("div", { class: "loading-circle" }, null, -1)
              ])))
            : _createCommentVNode("", true),
          (!$setup.loading)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($setup.leadsList, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["split-list-item grid-con grid-col", {active: ($setup.currentItem._id == item._id || $setup.selectedItem?._id == item._id)}]),
                  key: item._id,
                  onClick: ($event: any) => ($setup.selectItem(item))
                }, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString($setup.resolveName(item)), 1),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(item.email || "Email"), 1),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(item.lastContact || "Today"), 1),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(item.phone || "Phone"), 1)
                  ])
                ], 10, _hoisted_5))
              }), 128))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("button", {
          class: "icon secondary",
          onClick: $setup.createNewLead
        }, _cache[1] || (_cache[1] = [
          _createElementVNode("svg", {
            class: "icon add",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, [
            _createElementVNode("path", {
              class: "path filled",
              d: "M12 4C11.3688 4 10.8571 4.51167 10.8571 5.14286V10.8571H5.14286C4.51167 10.8571 4 11.3688 4 12V12C4 12.6312 4.51167 13.1429 5.14286 13.1429H10.8571V18.8571C10.8571 19.4883 11.3688 20 12 20V20C12.6312 20 13.1429 19.4883 13.1429 18.8571V13.1429H18.8571C19.4883 13.1429 20 12.6312 20 12V12C20 11.3688 19.4883 10.8571 18.8571 10.8571H13.1429V5.14286C13.1429 4.51167 12.6312 4 12 4V4Z"
            })
          ], -1),
          _createElementVNode("span", null, "New Lead", -1)
        ]))
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode($setup["LeadsDetails"], {
          email: $setup.email,
          interest: $setup.interest,
          "check-status": $setup.checkStatus,
          "lead-item": $setup.currentItem,
          loading: $setup.loading,
          "error-messages": $setup.errorMessages,
          onCreateCustAcct: $setup.createNewCustomer
        }, null, 8, ["email", "interest", "check-status", "lead-item", "loading", "error-messages"]),
        _createElementVNode("button", {
          class: "primary outline",
          onClick: $setup.clickSave
        }, "Save Changes")
      ])
    ])
  ]))
}